export enum RoutingPath {

  // General
  SUCCESS = 'success',
  ACCOUNT = 'account',

  ONBOARDING = 'onboarding',
  LOGIN = 'login',
  REGISTER = 'register',
  THEME = 'theme',

  FORGOT_PASSWORD = 'forgot-password',
  FORGOT_PASSWORD_TOKEN_PARAM = 'forgotPasswordToken',
  FORGOT_PASSWORD_VERIFICATION = 'verification',
  FORGOT_PASSWORD_NEW_PASSWORD = 'new-password',

  HOME = 'home',
  DEVELOPMENTS = 'developments',
  DEVELOPMENT_ID_PARAM = 'developmentId',
  UNIT_ID_PARAM = 'unitId',
  FULL_SPECS = 'full-specs',
  PRICING_TABLE = 'pricing-table',
  SALES_MIRROR = 'sales-mirror',
  GALLERY = 'gallery',
  DIGITAL_BOOK = 'digital-book',
  DESCRIPTIVE_MEMORIAL = 'descriptive-memorial',
  VIRTUAL_TOUR = 'virtual-tour',
  MARKETING_MATERIALS = 'marketing-materials',
  FAVORITES = 'favorites',
  NEWS = 'news',
  NOTIFICATIONS = 'notifications',
  CONTACT = 'contact',
  CONFIGS = 'configs',
  PAGE_SLUG_PARAM = 'pageSlug',
}
